// Simple authentication configuration for demo deployment
// In production, this would be replaced with proper IDAM integration

const AUTH_CONFIG = {
  // Demo users for testing - replace with your preferred credentials
  users: [
    {
      id: '1',
      email: 'demo@pocuscloud.com',
      password: 'PocusDemo2025!',
      name: 'Demo User',
      role: 'physician'
    },
    {
      id: '2', 
      email: 'test@pocuscloud.com',
      password: 'TestUser2025!',
      name: 'Test User',
      role: 'physician'
    },
    {
      id: '3',
      email: 'admin@pocuscloud.com', 
      password: 'AdminUser2025!',
      name: 'Admin User',
      role: 'admin'
    }
  ],
  
  // Session configuration
  sessionTimeout: 24 * 60 * 60 * 1000, // 24 hours in milliseconds
  
  // Simple token generation (in production, use proper JWT)
  generateToken: (user) => {
    const timestamp = Date.now();
    const payload = btoa(JSON.stringify({ 
      userId: user.id, 
      email: user.email,
      timestamp 
    }));
    return `demo_${payload}_${timestamp}`;
  },
  
  // Validate credentials
  validateCredentials: (email, password) => {
    const user = AUTH_CONFIG.users.find(u => 
      u.email.toLowerCase() === email.toLowerCase() && 
      u.password === password
    );
    return user ? { ...user, password: undefined } : null; // Remove password from returned user
  },
  
  // Validate token
  validateToken: (token) => {
    try {
      if (!token || !token.startsWith('demo_')) return false;
      
      const parts = token.split('_');
      if (parts.length !== 3) return false;
      
      const timestamp = parseInt(parts[2]);
      const now = Date.now();
      
      // Check if token is expired
      if (now - timestamp > AUTH_CONFIG.sessionTimeout) return false;
      
      const payload = JSON.parse(atob(parts[1]));
      return payload.userId && payload.email;
    } catch (error) {
      return false;
    }
  }
};

export default AUTH_CONFIG;
